
import Vue from "vue";
import { getTransaction } from "@/api/declinedTransactions/api";
import DataTable from "@/components/DataTable.vue";
import { GetDeclinedTransactionResponse } from "@/api/declinedTransactions/types";
import formatDateTime from "@/plugins/filters/dateTimeFormatFilter";
import store from "@/store";
import { DECLINED_TRANSACIONS } from "@/store/declinedTransactions";
import { ROUTE_NAMES } from "@/routes";
import { UI } from "@/store/ui";
import { ERROR_MESSAGES } from "@/constants/errors";
import { DECLINED_TRANSACTIONS_ROUTE_NAMES } from "@/declined-transactions-routes";

export default Vue.extend({
  data() {
    return {
      isLoading: false,
      transactionData: null as GetDeclinedTransactionResponse | null,

      headers: [
        { sortable: false, text: "Product", value: "product" },
        { sortable: false, text: "Quantity", value: "quantity" },
        { sortable: false, text: "Value", value: "value" },
      ],
    };
  },
  computed: {
    search_transactions_route: () =>
      DECLINED_TRANSACTIONS_ROUTE_NAMES.SEARCH_DECLINED_TRANSACTIONS,
    formatedDateTime: {
      get() {
        return this.transactionData
          ? formatDateTime(
              this.transactionData.transactionDateTime,
              "dd/MM/yyy hh:mm a"
            )
          : "";
      },
    },
    declineDescription: {
      get() {
        return store.state.declinedTransactions.declineCodes.find(
          (code) => code.declineCode === this.transactionData?.declineCode
        )?.declineDescripton;
      },
    },
  },
  props: {
    transactionId: {
      type: String,
    },
  },
  methods: {
    /**
     * Fetch the data from the server. Doesn't use state as
     * that would be overkill for this data.
     */
    async refresh_data() {
      try {
        await this.$store.dispatch(
          DECLINED_TRANSACIONS.NS(
            DECLINED_TRANSACIONS.ACTIONS.LOAD_DECLINE_CODES
          )
        );
        this.transactionData = await getTransaction(this.transactionId);
      } catch (error: any) {
        if (error.response && error.response.status === 404) {
          this.$router.push({
            name: ROUTE_NAMES.NOT_FOUND,
          });
        } else {
          this.$store.dispatch(
            UI.NS(UI.ACTIONS.ADD_TOAST),
            {
              id: "failed-load-declined-transaction",
              text: ERROR_MESSAGES.LOAD_DECLINED_TRANSACTIONS_DETAIL_ERROR,
              error,
            },
            { root: true }
          );
        }
      }
    },
  },
  async mounted() {
    this.refresh_data();
  },
  components: {
    "data-table": DataTable,
  },
});
